// shared/ko/bindings/money.js
import ko from 'knockout';

const moneyBinding = {
    update: function (element, valueAccessor, allBindings) {
        const value = ko.unwrap(valueAccessor());

        if (isNaN(value)) {
            element.textContent = '-';
            return;
        }

        const currency = ko.unwrap(allBindings.get('currency')) ?? 'EUR';
        const locale = ko.unwrap(allBindings.get('locale')) ?? navigator.language;
        
        const formatter = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency,
        });

        element.textContent = formatter.format(value);
    }
};

ko.bindingHandlers.money = moneyBinding;

export default moneyBinding;
